/*eslint-disable*/
import jump from 'jump.js'
import Flickity from 'flickity'
require('flickity-bg-lazyload')
// FIXME: When importing flickity globally on theme.liquid it breaks importing it within single files!
//        see: https://github.com/metafizzy/flickity/issues/484

export default klpPageHeader => {
  $(document).ready(() => {
    if ($('#wrapper').hasClass('brand-klp')) {
      $('.header__main').addClass('brand-klp')
    } else if ($('#wrapper').hasClass('ss-klp')) {
      $('.header__main').addClass('ss-klp')
    }
  })
  $(window).scroll(() => {
    window.scrollY < 20
      ? $('.header__main').removeClass('is-scrolled')
      : $('.header__main').addClass('is-scrolled')
  })

  let $header = $(klpPageHeader).find('.klp__header')
  let $pressSlider = $header.find('.klp-hero_value-module_press')
  $('.header__main_block').addClass($header.data('nav-color'))

  if ($pressSlider.get(0)) {
    const flkty = new Flickity($pressSlider.get(0), {
      contain: true,
      pagedots: true,
      prevNextButtons: false,
      autoPlay: 7000,
      wrapAround: true
    })

    setTimeout(() => {
      $pressSlider.find('.flickity-slider').get(0).childNodes.length > 1 && $pressSlider.closest('.flickity-enabled').find('.flickity-page-dots').css('opacity', 1)
      flkty.resize()
    }, 1500)

    flkty.on('dragStart', (event, pointer) => { document.ontouchmove = e => e.preventDefault() })
    flkty.on('dragEnd', (event, pointer) => { document.ontouchmove = e => true })

    setTimeout(() => {
      $pressSlider.find('.flickity-viewport').addClass('x y')
      flkty.resize()
    }, 1500)

    flkty.on('change', () => {
      setTimeout(() => {
        flkty.playPlayer()
      }, 7000)
    })
  }

  let snowePropHeaders = klpPageHeader.querySelectorAll('.prop_title')
  snowePropHeaders.forEach(propHeader => {
    propHeader.addEventListener('click', (e) => {
      $(e.target).closest('.prop').toggleClass('open')
    })
  })

  const exploreSlideshow = klpPageHeader.querySelector('.js-explore-carousel')
  let exploreFlkty
  if (exploreSlideshow) {
    exploreFlkty = new Flickity(exploreSlideshow, {
      contain: true,
      prevNextButtons: false,
      draggable: false,
      // selectedAttraction: 0.01,
      bgLazyLoad: true,
      lazyLoad: 1,
      pageDots: false,
      // friction: 0.15,
      wrapAround: true,
      autoPlay: 7000,
      on: {
        change: function (idx) {
          let categoryExploreNavItems = klpPageHeader.querySelectorAll('.klp_category-explore_nav-item h4')
          let categoryexploreCopySlides = klpPageHeader.querySelectorAll('.klp_category-explore_slide_copy.desktop')
          categoryExploreNavItems.forEach(navItem => $(navItem).data('index') !== idx && navItem.classList.remove('active'))
          categoryexploreCopySlides.forEach(copySlide => copySlide !== $(`#copy-${idx}`).get(0) && $(copySlide).removeClass('active z1'))
          $(`#copy-${idx}`).addClass('active z1')
          $(`.klp_category-explore_nav-item h4[data-index=${idx}]`).addClass('active')
        }
      }
    })

    exploreFlkty.on('dragStart', (event, pointer) => { document.ontouchmove = e => e.preventDefault() })
    exploreFlkty.on('dragEnd', (event, pointer) => { document.ontouchmove = e => true })
    setTimeout(() => {
      exploreFlkty.resize()
    }, 1500)
    let categoryExploreNavItems = klpPageHeader.querySelectorAll('.klp_category-explore_nav-item')
    let categoryexploreCopySlides = klpPageHeader.querySelectorAll('.klp_category-explore_slide_copy.desktop')
    categoryExploreNavItems.forEach(navItem => {
      navItem.addEventListener('click', (e) => {
        if (!e.target.classList.contains('active')) {
          categoryExploreNavItems.forEach(navItem => $(navItem).get(0) !== $(e.target).closest('.klp_category-explore_nav-item').get(0) && navItem.querySelector('h4').classList.remove('active'))
          e.target.classList.add('active')
          let slideIndex = $(e.target).data('index')
          exploreFlkty && exploreFlkty.select(slideIndex)
          categoryexploreCopySlides.forEach(copySlide => copySlide !== $(`#copy-${slideIndex}`).get(0) && copySlide.classList.remove('active'))
          $(`#copy-${slideIndex}`).addClass('active')
        }
      })
    })
  }
  const jumpLink = document.querySelector('.js-explore-home')

  jumpLink.addEventListener('click', () => {
    jump('.klp-hero_value-module', {
      offset: -125
    })
  })
}



// WEBPACK FOOTER //
// ./src/scripts/components/klp-global.js